import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { dateToInput, dateFormat } from '../lib/utils.js';
import { styles } from '../styles/shared-styles.js';

@customElement('form-start-session')
export class FormStartSession extends LitElement {
  static styles = [
    styles,
    // css``
  ];

  @property({ type: Object, attribute: false }) session;
  @property({ attribute: false }) handleSubmit;
  @property({ attribute: false }) fastingGoalInMs;

  onInput(e) {
    const date = new Date(e.target.value);
    this.session.startedAt = date;
    this.requestUpdate();
  }

  render() {
    const session = this.session;

    const buttonLabel = session.saved ? 'Update start time' : "Let's go!";
    const inputLabel = session.saved ? 'Adjust your start time' : 'When did you start?';
    const now = new Date();

    return html`

      <form @submit=${this.handleSubmit}>
        <p>
        <sl-input
          @input=${this.onInput}
          required
          type="datetime-local"
          name="startedAt"
          label=${inputLabel}
          value=${dateToInput(session.startedAt)}
          max=${dateToInput(now)}
        ></sl-input>
        </p>


        <p>
          <span class="muted-text">Your fasting will end at:</span>
          ${dateFormat(session.endsAtGoal)}
        </p>

        <br>

        <div class="flex-ends">
          <sl-button type="submit" variant="primary">${buttonLabel}</sl-button>
        </div>
      </form>
    `;
  }
}

